import React, { useReducer, useRef } from 'react'
import { useDialogActions } from 'cityads-v3/hooks/dialog'
import { useThemeChanger } from 'cityads-v3/hooks/theme'
import classes from './HeaderTheme.scss'

import Brightness2OutlinedIcon from '@mui/icons-material/Brightness2Outlined'
import Brightness6OutlinedIcon from '@mui/icons-material/Brightness6Outlined'
import IconButton from '@mui/material/IconButton'
import Popover from '@mui/material/Popover'
import ThemeChanger from 'cityads-v3/components/ThemeChanger/ThemeChanger';
import WbSunnyOutlinedIcon from '@mui/icons-material/WbSunnyOutlined'

export default function HeaderTheme(): JSX.Element {
  const [open, setOpen, setClose] = useDialogActions()
  const anchorEl = useRef();
  const [, refresh] = useReducer(num => num + 1, 0)

  const { themeName } = useThemeChanger()
  const isSystem = window?.localStorage?.theme === 'system';

  return (
    <>
      <IconButton
        disableRipple
        edge="end"
        classes={{ root: classes.button }}
        ref={anchorEl}
        onClick={setOpen}
        size="small"
      >
        {!isSystem && themeName === 'light' ? <WbSunnyOutlinedIcon sx={{ width: 16, height: 16 }} /> : null}
        {isSystem ? <Brightness6OutlinedIcon sx={{ width: 16, height: 16 }} /> : null}
        {!isSystem && themeName === 'dark' ? <Brightness2OutlinedIcon sx={{ width: 16, height: 16 }} /> : null}
      </IconButton>

      <Popover
        anchorEl={anchorEl.current}
        open={open}
        onClose={setClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <ThemeChanger onChange={refresh} />
      </Popover>
    </>
  )
}
